import React from 'react';
import { FormattedMessage } from '../../localization';
import './Features.scss';

const Features = ({ className }: { className?: string }) => {
  const copies = [
    {
      icon: 'selections',
      title: {
        id: 'vastCatalogue',
        defaultMessage: 'Vast Catalogue of Your Favourite Content'
      },
      body: {
        id: 'enjoyDiverse',
        defaultMessage: 'Enjoy a diverse selection of content from various genres, offering something for everyone.'
      }
    },
    {
      icon: 'no_circle',
      title: {
        id: 'noAds',
        defaultMessage: 'No Ads'
      },
      body: {
        id: 'justFun',
        defaultMessage: 'Just fun and entertaining videos without the interruptions.'
      }
    },
    {
      icon: 'compatibility',
      title: {
        id: 'seamless',
        defaultMessage: 'Seamless Cross-Platform Compatibility'
      },
      body: {
        id: 'enjoyContent',
        defaultMessage: 'Enjoy your content on any device—PC, tablet, or smartphone—without sacrificing performance.'
      }
    }
  ];
  return (
    <div className="features">
      {copies.map((item) => {
        return (
          <div className={`feature ${className || ''}`} key={item.title.id}>
            <img className="mb-4" src={require(`../../assets/imgs/${item.icon}.svg`)} alt="" />
            <h4>
              <FormattedMessage id={item.title.id} defaultMessage={item.title.defaultMessage} />
            </h4>
            <div className="divider" />
            <p>
              <FormattedMessage id={item.body.id} defaultMessage={item.body.defaultMessage} />
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default Features;
